<template>
  <v-container style="min-height:70vh" grid-list-xl>
    <v-layout
      flex-child
      wrap
    >
      <v-flex
        xs0
        md4
        d-flex
      >
      </v-flex>
      <v-flex
        xs12
        md6
        d-flex
      >
        <v-layout wrap>
          <v-flex xs6>
            <v-sheet
              class="d-flex"
              color="transparent"
              height="150"
              width="500"
              style="padding:40px"
            >
              <span>
                <svg width="110" height="110" viewBox="0 0 110 110" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect y="20" width="50" height="50" fill="#DBFF00" fill-opacity="0.33"/>
                  <rect x="30" width="50" height="50" fill="#6CE5FF" fill-opacity="0.33"/>
                  <rect x="30" y="20" width="50" height="50" fill="#FF0000" fill-opacity="0.33"/>
                </svg>
              </span>
            </v-sheet>
            <p>Welcome to Smartpress, {{ user.username }}.</p>
          </v-flex>
          <v-flex xs12
              @click="openTemplates()" 
              style="cursor:pointer">
            <v-sheet
              class="d-flex"
              color="transparent"
              height="200"
              width="200"
            >
              <span  style="border: dashed 2px gray; border-radius:30px;" >
                <span style="position:relative;left:85px; top:70px" flat class="margin:auto"><span style="font-size:40px">+</span></span>
              </span>


            </v-sheet>
            <h6 style="margin:6px; font-weight:600">Create project +</h6>

            
            <div class="box" style="background-color:#796EFF; position: relative; left:220px;top:-150px; width:200px">
              
              <v-card-text style="color:white;">
                Click here to start your first project.
              </v-card-text>
              <div   class="arrow"></div>
            </div>
            
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import dbcompile  from '../components/db-compile/SecureDeploy'
import store from "@/store"
import router from "@/router"

export default {
    components: {
      dbcompile
    },
    computed: {
        ...mapState({
            user: state => state.auth.user,
            // message: state => state.util.message,
        })
    },
    created: function () {
      this.newUser()
    },
    methods: {
      openTemplates() {
        router.push("contractTemplates")
      },
      newUser() {

        let email = this.$cookies.get('spUserEmail')
        this.$store.dispatch('contractsDb/getUser', {
            username: this.user.username,
            email: email
          }
        )
      },
      // testPing() {
      //   this.$store.dispatch('util/testPing')
      // },
      // resetMessage() {
      //   this.$store.dispatch('util/resetMessage')
      // },
    }
}
</script>

<style>

  .box:before {
    content: "";
    position: absolute;
    top: 50%;                         
    margin-top: -15px;                
    left:-25px;
    border: solid 10px transparent;
    border-right: solid 15px #796EFF;
    z-index: 1;
}
</style>
